const REACT_APP_BASE_URL = "https://erp.webdoc.com.pk/afghan.php";
// const REACT_APP_BASE_URL = "https://bankalfalah.webddocsystems.com/afghan.php"

// This code is just for testing in ci4 project
// const REACT_APP_BASE_URL = "https://Digital.webdoc.com.pk/claimportal/public/service/";


export { REACT_APP_BASE_URL };
